import React from 'react';

import classNames from 'classnames';

import {CloudinaryImage} from 'components/cloudinaryImage/cloudinaryImage';

import {BannerContentType} from '../../types';
import {getBannerImage} from '../../utils/utils';

import {BannerBadge} from './bannerBadge/bannerBadge';
import {getBannerBadgeOptions} from './bannerBadge/getBannerBadgeOptions';
import {BannerTextBlock} from './bannerTextBlock/bannerTextBlock';

import s from './imageBanner.scss';

export type PropsType = {
    data: BannerContentType;
    fallbackBannerData?: Partial<BannerContentType>;
};

/**
 * A banner based on a template
 */
export const ImageBanner: React.FC<PropsType> = ({data, fallbackBannerData = {}}) => {
    const fallbackH1Text =
        String(data?.display_title_inside_banner) === 'true'
            ? fallbackBannerData?.banner_h1_text
            : '';

    const image = getBannerImage(data);

    if (!image) return null;

    const bannerBadge = getBannerBadgeOptions(data);

    return (
        <div
            className={classNames(s.bannerImageContainer, {
                [s.isSmall]: data.height === 'small',
            })}
        >
            {bannerBadge && (
                <BannerBadge
                    height={bannerBadge.height}
                    icon={bannerBadge.badge}
                    link={bannerBadge.link}
                    position={bannerBadge.position}
                />
            )}
            <CloudinaryImage
                alt={data.bannerAlt || 'Banner image'}
                className={s.image}
                src={image}
            />
            <BannerTextBlock
                bannerH1Color={data.banner_h1_color}
                bannerH1Text={data.banner_h1_text || fallbackH1Text}
                bannerH2Color={data.banner_h2_color}
                bannerH2Text={data.banner_h2_text}
                isDark={data.theme?.toLowerCase() === 'dark'}
            />
        </div>
    );
};
